import * as React from 'react';
import './checkmarklist.scss';
import { IconCheckmark } from '../../basics/icons';

interface Props {
  list: (React.ReactNode | string)[];
  checkMarkStyle?: string;
  header?: string;
}

export const CheckMarkList: React.FC<Props> = ({ header, list, checkMarkStyle = '' }) => {
  if (!list.length) return null;
  return (
    <div className={'check-mark-list'}>
      {header && <div className={'check-mark-list--header'}>{header}</div>}
      {list.map((item, key) => {
        return (
          <div key={key} className={'check-mark-list--item'}>
            <div className={'check-mark-list--icon pt-[0.4rem]'}>
              <IconCheckmark checkMarkStyle={checkMarkStyle} />
            </div>
            <div className={'check-mark-list--text'}>{item}</div>
          </div>
        );
      })}
    </div>
  );
};
export default CheckMarkList;
